export enum MESSAGE_TITLE {
    ERROR = 'Error',
    SUCCESS = 'Success',
}
